import React from 'react';
import {Flex, Space, theme, Typography} from "antd";
import {
    FacebookFilled,
    InstagramFilled,
    MailFilled,
    TikTokFilled,
    YoutubeFilled
} from "@ant-design/icons";
import {Link} from "react-router-dom";
// @ts-ignore
import { CookieBanner } from '@keepist/react-gdpr-cookie-banner';
import {useTranslation} from "react-i18next";

export const RpgLauncherFooter: React.FC<{disableNavigation?: boolean}> = ({disableNavigation}) => {
    const { useToken } = theme;
    const {token} = useToken();
    const {t} = useTranslation();

    return (
        <div id="rpg-launcher-layout-footer" style={{
            zIndex: 999999,
            height: '200px',
            backgroundColor: token.colorPrimaryBg,
            maxWidth: '100%',
            overflowX: 'scroll',
            padding: '20px',
        }}>
            <CookieBanner
                privacyPolicyLinkText={t('footer.cookie.privacy.policy.text')}
                policyLink={'/privacy-policy'}
                message={t('footer.cookie.message')}
                necessaryOptionText={t('footer.cookie.required')}
                acceptAllButtonText={t('footer.cookie.accept.all.text')}
                acceptSelectionButtonText={t('footer.cookie.accept.selection.text')}
                showAcceptAllOption={false}
                showAcceptSelectionButton={true}
                showPreferencesOption={false}
                showStatisticsOption={false}
                showMarketingOption={false}
                styles={{
                    dialog: { padding: '5px', position: 'absolute', bottom: '10px', backgroundColor: 'white', width: '90%', borderRadius: '5px', boxShadow: '2px 2px' },
                }}
            />
            <Typography.Title level={5}>Powered by RPG Lodge</Typography.Title>
            <Space direction={"horizontal"}>
                <Space direction={"vertical"}>
                    <Typography.Text>Βρείτε μας παρακάτω</Typography.Text>
                    <Flex justify={"start"} align={"center"}>
                        <Link to={'https://www.facebook.com/rpglodge'}> <FacebookFilled
                            style={{fontSize: '32px', marginRight: '3px'}}/> </Link>
                        <Link to={'https://instagram.com/therpglodge'}> <InstagramFilled
                            style={{fontSize: '32px', marginRight: '3px'}}/> </Link>
                        <Link to={'mailto:therpglodge@gmail.com'}> <MailFilled
                            style={{fontSize: '32px', marginRight: '3px'}}/> </Link>
                        <Link to={'https://www.youtube.com/@rpglodge1348'}> <YoutubeFilled
                            style={{fontSize: '32px', marginRight: '3px'}}/> </Link>
                        <Link to={'https://tiktok.com/@the.rpg.lodge'}> <TikTokFilled
                            style={{fontSize: '32px', marginRight: '3px'}}/> </Link>
                    </Flex>
                </Space>
                {!disableNavigation &&
                    <>
                        <Space direction={"vertical"} style={{marginLeft: '20px', width: '100px'}}>
                            <Link to={'/'}>Home</Link>
                            <Link to={'/terms-and-conditions'}>Service Terms</Link>
                            <Link to={'/privacy-policy'}>Privacy Policy</Link>
                            <Link to={'/contact'}>Contact</Link>
                        </Space>
                    </>
                }
            </Space>
        </div>
    );
};
